import { Space, Typography } from 'antd';
import styled from 'styled-components';
import { blueLink, grayDark03, grayDark06, grayLight04 } from '../../../styles/colors';
import { ClickableRow } from '../../../styles/common.styles';
import { CustomizedTable } from '../../common/table/CustomTable.styles';
import { NavLink } from 'react-router-dom';

export const TagListContainer = styled('div')`
    display: flex;
    flex-direction: column;
`;

export const TagsTableSpace = styled(Space)`
    margin: 0px 0 10px 0;
    align-items: end;
    width: 100%;
    justify-content: space-between;

    &.align-top {
        align-items: start;
    }
`;

export const TagProductsTable = styled(CustomizedTable)<{ readOnly: boolean, sortDirection: string }>`
    .ant-table-thead > tr > th {
        background: unset;
        border-bottom: 1px solid ${grayDark06};
        font-family: 'Proxima N W15 Bold';
        font-weight: normal;
        font-size: 10px;
        line-height: 12px;
        text-transform: uppercase;
        &::before {
            content: unset !important;
        }
    }
    .ant-table-tbody > tr > td {
        background: none;
        vertical-align: top;
    }
    .ant-table-tbody > tr > td.ant-table-selection-column {
        vertical-align: top;
    }
    .ant-table-thead > tr > th {
        padding: 8px 16px;
    }
    .ant-table-thead > tr > th:nth-child(2),
    .ant-table-tbody > tr > td:nth-child(2) {
        padding-left: 0;    
    }
    .ant-table-thead > tr > th:first-child,
    .ant-table-tbody > tr > td:first-child {
        padding-right: 8px;
        padding-left: 4px;    
    }
    .ant-table-tbody > tr:nth-child(odd) > td {
        background: ${grayLight04};
    }
`;

export const TagGroup = styled('div')`
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    margin-top: 16px;
`;

export const UnselectAllButton = styled(ClickableRow)`
    white-space: nowrap;
    color: ${blueLink};
    font-family: 'Proxima Nova';
`;

export const TagDropdownOption = styled('span')`
    display: flex;
    margin-left: 11px;
    align-items: center;
    gap: 8px;
`;

export const EditableTagOption = styled('span')`
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const TableRow = styled(Typography.Text)`
    color: ${grayDark03};
    font-family: "Proxima Nova";
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

export const ProductCell = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ManufacturerText = styled('span')`
    font-family: 'Proxima N W15 Bold';
    font-size: 13px;
    line-height: 16px;
    color: ${grayDark03};
`;

export const ProductNameText = styled('span')`
    font-family: 'Proxima Nova';
    font-size: 13px;
    line-height: 16px;
    color: ${grayDark03};
`;

export const ProductTextLink = styled('a')`
    color: ${blueLink};
    text-decoration: none;
    &:hover {
        color: ${blueLink};
        text-decoration: underline;
    }
`;

export const ProjectLibraryText = styled('span')`
    color: ${grayDark03};
    font-family: 'Proxima Nova';
    font-size: 13px;
    line-height: 16px;
`;

export const ReturnToTagLink = styled(NavLink)`
    display: flex;
    align-items: center;
    gap: 8px;
    &: hover {
        text-decoration: underline;
    }
`;